import { Injectable } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { CookiesConsentComponent } from '../components/cookies-consent/cookies-consent.component'
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer'

@Injectable({
  providedIn: 'root',
})
export class CookiesConsentService {
  constructor(private cookieService: CookieService, private drawerService: NzDrawerService) {}

  private readonly cookieName: string = '__spas_cookies_consent'
  private readonly expirationYears: number = 2
  private readonly acceptedConsentCookieValue: string = 'true'
  private readonly declienedConsentCookieValue: string = 'false'
  private drawerRef: NzDrawerRef

  public open(): void {
    this.drawerRef = this.drawerService.create<CookiesConsentComponent, any>({
      nzHeight: '100px',
      nzPlacement: 'bottom',
      nzContent: CookiesConsentComponent,
      nzClosable: false,
      nzMask: false,
      nzWrapClassName: 'cookies-consent-drawer',
    })
  }

  public close(): void {
    if (this.drawerRef != null && !this.cookieConsentAccepted()) {
      this.drawerRef.close()
    }
  }

  cookieConsentAccepted(): boolean {
    if (this.cookieService.check(this.cookieName)) {
      const existingValue: string = this.cookieService.get(this.cookieName)
      if (
        existingValue === this.acceptedConsentCookieValue ||
        existingValue === this.declienedConsentCookieValue
      ) {
        return true
      }
    }

    return false
  }

  setCookieConsent(isAccepted: boolean): void {
    const expirationDate: Date = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + this.expirationYears)

    this.cookieService.set(this.cookieName, String(isAccepted), expirationDate)
    this.drawerRef.close()
  }
}
